<template>
  <div
    v-if="isActive"
    class="basemap-panel"
    :style="panelStyle"
    @mousedown="onDragStart"
  >
    <div class="map-tool-window-header" @mousedown="onDragStart">
      <span class="map-tool-window-header-title">Cambiar Mapa Base</span>
      <div class="map-tool-window-header-actions">
        <button class="control-btn" @click.stop="minimized = !minimized">
            <svg  v-if="minimized"
            viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <svg v-else
              viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>
        </button>
        <button class="control-btn" title="Cerrar" @click.stop="close">
              <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
        </button>
      </div>
    </div>
    <div v-if="!minimized" class="basemap-grid">
      <div
        v-for="item in catalog"
        :key="item.id"
        class="basemap-card"
        :class="{ active: item.id === activeId }"
        @click="select(item)"
      >
        <img :src="item.thumbnail" :alt="item.name" @error="onThumbError" />
        <div class="basemap-name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { vuex } from "@/components/mixin/vuex.js";
import { mapService } from "@/services/map/mapService.js";
import {
  baseMapCatalog,
  DEFAULT_BASEMAP_ID,
  PLACEHOLDER_THUMB_URL,
} from "@/components/mapTools/baseMap/baseMapCatalog.js";

export default {
  name: "ChangeBasemap",
  mixins: [vuex],
  data() {
    return {
      catalog: baseMapCatalog,
      activeId: DEFAULT_BASEMAP_ID,
      minimized: false,
      pos: { top: 80, left: 80 },
      drag: null,
    };
  },
  computed: {
    isActive() {
      return this.mapToolValues("basemap").active;
    },
    panelStyle() {
      return { top: this.pos.top + "px", left: this.pos.left + "px" };
    },
  },
  methods: {
    select(item) {
      mapService.changeBaseMap(item);
      this.activeId = item.id;
      //this.close(); 
      //segun observacion SENAPRED 06/2026 ("La herramienta (Capas Temáticas / Mapas Base) no se debe cerrar al escoger un mapa base.")
    },
    close() {
      this.selectMapTool("basemap", false);
    },
    onDragStart(e) {
      if (e.target.tagName === "BUTTON") return;
      if (e.target.closest(".basemap-grid")) return;
      this.drag = {
        x: e.clientX - this.pos.left,
        y: e.clientY - this.pos.top,
      };
      window.addEventListener("mousemove", this.onDragMove);
      window.addEventListener("mouseup", this.onDragEnd);
    },
    onDragMove(e) {
      if (!this.drag) return;
      this.pos = {
        left: e.clientX - this.drag.x,
        top: e.clientY - this.drag.y,
      };
    },
    onDragEnd() {
      this.drag = null;
      window.removeEventListener("mousemove", this.onDragMove);
      window.removeEventListener("mouseup", this.onDragEnd);
    },
    onThumbError(e) {
      if (e.target.src !== PLACEHOLDER_THUMB_URL) {
        e.target.src = PLACEHOLDER_THUMB_URL;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onDragMove);
    window.removeEventListener("mouseup", this.onDragEnd);
  },
};
</script>

<style scoped lang="scss">
.basemap-panel {
  position: fixed;
  width: 320px;
  max-height: 70vh;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  z-index: 100000001;
  display: flex;
  flex-direction: column;
  user-select: none;
}

.basemap-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #e0e0e0;
  cursor: move;
  font-weight: 600;
  background: #f9f9f9;
  border-radius: 8px 8px 0 0;
}

.basemap-title {
  font-size: 14px;
}

.header-actions {
  display: flex;
  gap: 4px;
}

.btn-icon {
  background: none;
  border: none;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 2px 8px;
  color: #333;
  border-radius: 4px;

  &:hover {
    background: #e5e5e5;
  }
}

.basemap-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 12px;
  overflow-y: auto;
  max-height: calc(70vh - 48px);
}

.basemap-card {
  cursor: pointer;
  text-align: center;
  border: 2px solid transparent;
  border-radius: 6px;
  padding: 4px;
  transition: border-color 0.15s, background 0.15s;
  background: #fafafa;

  &:hover {
    border-color: #bbb;
    background: #f0f0f0;
  }

  &.active {
    border-color: #1976d2;
    background: #e3f2fd;
  }

  img {
    width: 100%;
    height: 90px;
    object-fit: cover;
    border-radius: 4px;
    display: block;
    background: #ddd;
  }
}

.basemap-name {
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.2;
  color: #333;
}
</style>
